export default (videoUri) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'auto';

    video.src = videoUri;
    video.crossOrigin = 'Anonymous';
    video.type = 'video/mp4';
    // wait till the clip is ready before taking the thumbnail
    video.addEventListener('canplay', () => {
      const scale = 1;
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth * scale;
      canvas.height = video.videoHeight * scale;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

      return resolve({ path: canvas.toDataURL() });
    });

    video.addEventListener('error', () => {
      return reject(null);
    });
  });
};
